import { render } from "./textarea.vue?vue&type=template&id=67682a7a"
import script from "./textarea.vue?vue&type=script&lang=js"
export * from "./textarea.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/components/form/horizontal/textarea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "67682a7a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('67682a7a', __exports__)) {
    console.log('reload')
    api.reload('67682a7a', __exports__)
  }
  
  module.hot.accept("./textarea.vue?vue&type=template&id=67682a7a", () => {
    console.log('re-render')
    api.rerender('67682a7a', render)
  })

}


export default __exports__